import { Checkbox, Col, Form, FormInstance, InputNumber, Radio } from 'antd'

import { requiredRules } from 'src/app-constants'
import { useLocales } from 'src/locales'

type Props = {
  form: FormInstance
}

export const GeneralSymptomsCard = ({ form }: Props) => {
  const { t } = useLocales()

  const hasGeneralSymptoms =
    Form.useWatch(['form', 'symptoms', 'general', 'status'], form) === 'yes'

  const hasFever = Form.useWatch(
    ['form', 'symptoms', 'general', 'fever', 'isSelected'],
    form
  )

  return (
    <>
      <Col span={24}>
        <Form.Item
          name={['form', 'symptoms', 'general', 'status']}
          rules={requiredRules}
          label={`1. ${t('epidemiology.general')}`}
        >
          <Radio.Group>
            <Radio value="dontKnow">{t('epidemiology.unknown')}</Radio>
            <Radio value="no">{t('common.no')}</Radio>
            <Radio value="yes">{t('common.yes')}</Radio>
          </Radio.Group>
        </Form.Item>
      </Col>

      {hasGeneralSymptoms && (
        <>
          <Col span={8}>
            <Form.Item
              name={['form', 'symptoms', 'general', 'fever', 'isSelected']}
              valuePropName="checked"
            >
              <Checkbox>1. Febră</Checkbox>
            </Form.Item>
          </Col>

          {hasFever && (
            <Col span={8}>
              <Form.Item
                name={[
                  'form',
                  'symptoms',
                  'general',
                  'fever',
                  'temperature',
                  'value'
                ]}
                label="1.1 Temperatura (°C)"
              >
                <InputNumber
                  className="full-width"
                  min={32}
                  max={45}
                  placeholder="Temperatura"
                />
              </Form.Item>
            </Col>
          )}

          <Col span={8}>
            <Form.Item
              name={['form', 'symptoms', 'general', 'frisoane', 'isSelected']}
              valuePropName="checked"
            >
              <Checkbox>2. Frisoane</Checkbox>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'general',
                'pronouncedWeakness',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>3. Slăbiciune pronunțată</Checkbox>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'general',
                'seriousCondition',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>4. Stare gravă</Checkbox>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name={['form', 'symptoms', 'general', 'coma', 'isSelected']}
              valuePropName="checked"
            >
              <Checkbox>5. Comă</Checkbox>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'general',
                'persistentСrying',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>6. Plâns persistent</Checkbox>
            </Form.Item>
          </Col>
        </>
      )}
    </>
  )
}
